import { defineStore } from 'pinia';

export const useGeneralStore = defineStore('general', {
	state: () => ({
		general: null
	}),
	getters: {
		getGeneral(state) {
			return state.general;
		},
		isLicenseEnabled() {
			return process.env.VUE_APP_LICENSE_ENABLED;
		},
		getSiteName(state) {
			return state.general.site_name;
		}
	},
	actions: {
		setGeneral(data) {
			this.general = data;
		}
	},
})